import constants from '@/constants';

import getters from './getterTypes';

export default {
  [getters.byCompanyId]({ list }) {
    return (companyId) => list.find((item) => item.companyId === companyId);
  },

  [getters.withMissingUeFile]({ list }) {
    const missingStatus = constants.companyFiles.statuses.NOT_LOADED;

    return list.filter(({ projectFiles }) => {
      return (
        !!projectFiles &&
        Object.values(projectFiles).some(({ files }) => {
          if (!files) {
            return true;
          }

          const ueFile = files.find(({ fileName }) => fileName === 'ueFile');

          return !ueFile || !ueFile.status || ueFile.status === missingStatus;
        })
      );
    });
  },

  [getters.withCodeOfConductStatus]({ list }) {
    const unknownStatus = constants.companyFiles.codeOfConductStatuses.UNKNOWN;

    return (status) =>
      list.filter(({ projectFiles }) => {
        return (
          !!projectFiles &&
          Object.values(projectFiles).some(({ codeOfConduct }) => {
            if (!codeOfConduct || !codeOfConduct.status) {
              return status === unknownStatus;
            }

            return codeOfConduct.status === status;
          })
        );
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/companyFiles/getters.js